import { render } from "./EmailTemplateDetails.vue?vue&type=template&id=7556f026"
import script from "./EmailTemplateDetails.vue?vue&type=script&lang=js"
export * from "./EmailTemplateDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__